export type TGradients = 'main' | 'banner' | 'aero'

export type TGradientVariables = {
  [key in TGradients]: string
}

const gradientVariables: TGradientVariables = {
  main: 'linear-gradient(90deg, #00D900 53.92%, #FFFF00 100%)',
  banner: 'linear-gradient(0deg, rgba(17, 89, 157, 0.6), rgba(104, 147, 189, 1)), #6893BD',
  aero: 'linear-gradient(90deg, #0253A2 0%, #3395F5 49.99%)',
}

export default gradientVariables
